import type { FC } from "react";

import { ChevronBackwardIcon } from "@jti/brand-icons/chevron-backward";

import { HeaderNavListItem } from "../HeaderNavListItem";
import { NavPanel } from "../NavPanel";

import styles from "../../MobileNavigation.module.scss";

type SubmenuPanelProps = {
  panelId: string;
  isActive: boolean;
  title: string;
  onBack: () => void;
  panelRef: (node: HTMLElement | null) => void;
  disableTransition?: boolean;
  children: React.ReactNode;
};

export const SubmenuPanel: FC<SubmenuPanelProps> = ({
  panelId,
  isActive,
  title,
  onBack,
  panelRef,
  disableTransition,
  children,
}) => {
  const titleId = `${panelId}-title`;

  return (
    <NavPanel
      id={panelId}
      isActive={isActive}
      labelledById={titleId}
      disableTransition={disableTransition}
      ref={panelRef}
    >
      <header className={styles.panelHeader}>
        <HeaderNavListItem
          id={titleId}
          label={title}
          hasTextEmphasized={true}
          startIcon={ChevronBackwardIcon}
          onClick={onBack}
        />
      </header>
      <div className={styles.submenu}>{children}</div>
    </NavPanel>
  );
};
